import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import { providerColor } from '../utils/providerColors';

// 分类配色（与主题 teal + pink 一致）
const CATEGORY_COLORS: Record<string, string> = {
  asset: '#26a884',
  tool: '#147a63',
  knowledge: '#ff7ab8',
};

export default class ResourceCard extends Component {
  view() {
    const { card } = this.attrs;
    const { attrs, title, cover, providers, resourceId } = card;
    const rh = app.forum.attribute('resourceHub') || {};

    const category = rh.categories?.find((c: any) => c.key === attrs.category);
    const categoryLabel = category?.label || attrs.category;
    const typeLabel = category?.types?.find((t: any) => t.key === attrs.resourceType)?.label || attrs.resourceType;
    const categoryColor = CATEGORY_COLORS[attrs.category] || '#26a884';
    const softwareLabel = (attrs.software || []).map((s: string) => this.labelFor(rh.software, s)).join(' · ');
    const formatLabel = (attrs.formats || []).map((f: string) => f.toUpperCase()).join(' · ');

    return (
      <Link className="ResourceCard" href={app.route('resource', { id: resourceId })}>
        <div className="ResourceCard-cover">
          {cover ? (
            <img src={cover.attributes.thumbnailUrl || cover.attributes.url} loading="lazy" alt={title} />
          ) : (
            <div className="ResourceCard-placeholder">
              <i className="fas fa-cube" />
            </div>
          )}
          <div className="ResourceCard-badges">
            <span className="ResourceCard-typeBadge" style={'background:' + categoryColor}>
              {categoryLabel} · {typeLabel}
            </span>
            <span className={'ResourceCard-freeBadge' + (attrs.isFree ? ' is-free' : '')}>{attrs.isFree ? '免费' : '付费'}</span>
          </div>
        </div>
        <div className="ResourceCard-body">
          <div className="ResourceCard-title" title={title}>
            {title}
          </div>
          <div className="ResourceCard-meta">
            {softwareLabel && <span className="ResourceCard-chip">{softwareLabel}</span>}
            {formatLabel && <span className="ResourceCard-chip">{formatLabel}</span>}
          </div>
          <div className="ResourceCard-foot">
            <div className="ResourceCard-providers">
              {(providers || []).slice(0, 3).map((p: string) => (
                <span className="ResourceCard-provider" style={'background:' + providerColor(p)}>
                  {this.labelFor(rh.providers, p)}
                </span>
              ))}
            </div>
            <span className="ResourceCard-date">{attrs.createdAt ? attrs.createdAt.slice(0, 10) : ''}</span>
          </div>
        </div>
      </Link>
    );
  }

  labelFor(registry: any[], key: string) {
    return registry?.find((x: any) => x.key === key)?.label || key;
  }
}
